// SiteUp: tours guiados das telas principais (conversas, kanban, tarefas).
// Ensinam a MEXER. Persistência em ui_settings.guided_tours, nunca localStorage.
import { coachForRoute } from './onboardingRegistry';

export const TOUR_STATUS = Object.freeze({
  PENDENTE: 'pendente',
  PAUSADO: 'pausado',
  CONCLUIDO: 'concluido',
  PULADO: 'pulado',
});

export const TARGET_WAIT_MS = 1200;
export const TARGET_WAIT_INTERVAL_MS = 50;
export const TARGET_WAIT_ATTEMPTS = TARGET_WAIT_MS / TARGET_WAIT_INTERVAL_MS;

const step = (id, anchors, i18nSlug, extras = {}) => ({
  id,
  anchors,
  titleKey: `ONBOARDING.TOURS.${i18nSlug}.TITLE`,
  bodyKey: `ONBOARDING.TOURS.${i18nSlug}.BODY`,
  ...extras,
});

export const TOURS = Object.freeze({
  home: {
    key: 'home',
    version: 1,
    steps: [
      step(
        'abas',
        [
          '[data-testid="quick-filter-segment"]',
          '[data-testid="chat-list-segment-trigger"]',
        ],
        'HOME.ABAS'
      ),
      step(
        'gutter',
        ['[data-testid="conversation-workbench-list-gutter"]'],
        'HOME.GUTTER',
        {
          actionHintKey: 'ONBOARDING.TOURS.HOME.GUTTER.HINT',
          advanceOn: {
            event: 'dblclick',
            selector: '[data-testid="conversation-workbench-list-gutter"]',
          },
          // O Brasa demonstra o gesto: vai ate a barra e arrasta pra la e
          // pra ca antes de voltar a apontar. Pedido do Lucas em 23/08.
          demo: { kind: 'drag-x', distance: 56 },
        }
      ),
      step(
        'pin',
        [
          '[data-testid="conversation-card"]',
          '[data-testid="chat-list-section-queue"]',
        ],
        'HOME.PIN'
      ),
    ],
  },
  inbox_conversation: {
    key: 'inbox_conversation',
    version: 1,
    steps: [
      step(
        'responsavel',
        [
          '[data-testid="header-assignee-pill"]',
          '[data-testid="focus-spot-header"]',
        ],
        'CONVERSATION.RESPONSAVEL'
      ),
      step(
        'etapa',
        [
          '[data-testid="header-funnel-pill"]',
          '[data-testid="header-assignee-pill"]',
        ],
        'CONVERSATION.ETAPA'
      ),
      step(
        'ia',
        [
          '[data-testid="header-ai-pill"]',
          '[data-testid="ai-agent-pause-shortcut"]',
          '[data-testid="focus-spot-header"]',
        ],
        'CONVERSATION.IA'
      ),
      step(
        'tarefas_agenda',
        [
          '[data-testid="desktop-header-tasks"]',
          '[data-testid="desktop-header-agenda"]',
          '[data-testid="desktop-more-actions"]',
        ],
        'CONVERSATION.TAREFAS_AGENDA'
      ),
      step(
        'resolver',
        [
          '[data-testid="conversation-resolve"]',
          '[data-testid="desktop-more-actions"]',
        ],
        'CONVERSATION.RESOLVER'
      ),
      step(
        'compositor',
        ['[data-testid="conversation-composer"]'],
        'CONVERSATION.COMPOSITOR'
      ),
      step(
        'nota',
        [
          '[data-testid="conversation-private-note"]',
          '[data-testid="conversation-composer"]',
        ],
        'CONVERSATION.NOTA'
      ),
      step(
        'painel',
        [
          '[data-testid="focus-spot-contact-card"]',
          '[data-testid="focus-spot-sidebar"]',
          '[data-testid="conversation-workbench-rail"]',
        ],
        'CONVERSATION.PAINEL'
      ),
    ],
  },
  kanban_board: {
    key: 'kanban_board',
    version: 1,
    steps: [
      step(
        'funil',
        [
          '[data-testid="kanban-funnel-selector"]',
          '[data-testid="page-kanban"]',
        ],
        'KANBAN.FUNIL'
      ),
      step(
        'arrastar',
        ['[data-testid="kanban-column"]', '[data-testid="page-kanban"]'],
        'KANBAN.ARRASTAR'
      ),
      step(
        'dragbar',
        ['[data-testid="kanban-dragbar"]', '[data-testid="page-kanban"]'],
        'KANBAN.DRAGBAR'
      ),
      step(
        'limite',
        ['[data-testid="kanban-column"]', '[data-testid="page-kanban"]'],
        'KANBAN.LIMITE'
      ),
      step(
        'filtros',
        [
          '[data-testid="kanban-filter-trigger"]',
          '[data-testid="kanban-filter"]',
          '[data-testid="page-kanban"]',
        ],
        'KANBAN.FILTROS'
      ),
      step(
        'abas_card',
        ['[data-testid="kanban-card-tabs"]', '[data-testid="page-kanban"]'],
        'KANBAN.ABAS'
      ),
      step(
        'agenda',
        ['[data-testid="kanban-view-selector"]', '[data-testid="page-kanban"]'],
        'KANBAN.AGENDA'
      ),
    ],
  },
  // A Agenda e uma tela propria dentro do Kanban: o tour do quadro nao serve
  // aqui. Pedido do Lucas em 23/08, junto com a integracao com Google e a
  // diferenca entre tarefa e compromisso.
  kanban_board__agenda: {
    key: 'kanban_board__agenda',
    version: 1,
    steps: [
      step(
        'funil',
        [
          '[data-testid="agenda-funnel-selector"]',
          '[data-testid="page-agenda"]',
        ],
        'AGENDA.FUNIL'
      ),
      step(
        'visoes',
        ['[data-testid="agenda-views"]', '[data-testid="page-agenda"]'],
        'AGENDA.VISOES'
      ),
      step(
        'filtros',
        [
          '[data-testid="agenda-team"]',
          '[data-testid="agenda-search"]',
          '[data-testid="page-agenda"]',
        ],
        'AGENDA.FILTROS'
      ),
      step(
        'novo',
        ['[data-testid="agenda-new"]', '[data-testid="page-agenda"]'],
        'AGENDA.NOVO'
      ),
      step(
        'compromisso',
        ['[data-testid="agenda-appointments"]', '[data-testid="page-agenda"]'],
        'AGENDA.COMPROMISSO',
        // Reagendar arrastando e gesto vertical (o eixo do horario).
        { demo: { kind: 'drag-y', distance: 44 } }
      ),
      step(
        'google',
        ['[data-testid="agenda-google"]', '[data-testid="page-agenda"]'],
        'AGENDA.GOOGLE'
      ),
      step('tarefas', ['[data-testid="page-agenda"]'], 'AGENDA.TAREFAS'),
    ],
  },
  tasks: {
    key: 'tasks',
    version: 1,
    steps: [
      // TasksApp.vue é legado sujo: o CI linta o arquivo inteiro no diff.
      // Âncora estável já existente; o texto do passo ensina a ação.
      step('visoes', ['[data-testid="page-tasks"]'], 'TASKS.VISOES'),
      step('filtros', ['[data-testid="page-tasks"]'], 'TASKS.FILTROS'),
      step('criar', ['[data-testid="page-tasks"]'], 'TASKS.CRIAR'),
      step('lote', ['[data-testid="page-tasks"]'], 'TASKS.LOTE'),
      step('dentro', ['[data-testid="page-tasks"]'], 'TASKS.DENTRO'),
      step('agenda', ['[data-testid="page-tasks"]'], 'TASKS.AGENDA'),
    ],
  },
});

export const tourForRoute = (routeName, view = null) => {
  const coach = coachForRoute(routeName, view);
  if (!coach) return null;
  return TOURS[coach.key] || null;
};

export const tourRecordOf = (raw, key) => {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const record = raw[key];
  if (!record || typeof record !== 'object' || Array.isArray(record))
    return null;
  return record;
};

export const shouldStartTour = (tour, record) => {
  if (!tour) return false;
  if (!record) return true;
  const seen = Number(record.version);
  if (!Number.isFinite(seen) || seen < Number(tour.version)) return true;
  return (
    record.status === TOUR_STATUS.PENDENTE ||
    record.status === TOUR_STATUS.PAUSADO
  );
};

export const shouldResumeTour = (tour, record) => {
  if (!shouldStartTour(tour, record) || !record) return false;
  if (Number(record.version) !== Number(tour.version)) return false;
  if (record.status === TOUR_STATUS.PAUSADO) return true;
  return record.started === true && record.status === TOUR_STATUS.PENDENTE;
};

export const clampStepIndex = (tour, stepIndex) => {
  const last = Math.max(0, (tour?.steps || []).length - 1);
  const numeric = Number(stepIndex);
  if (!Number.isFinite(numeric) || numeric < 0) return 0;
  return Math.min(last, Math.floor(numeric));
};
